var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCardNextDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.30176,
    width: 8.19842,
    height: 8.19685,
    rx: 1.02461,
    fill: "#1C1C1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82715 4.09657C8.82715 3.78219 8.85457 3.52734 8.88839 3.52734H14.0213C14.0551 3.52734 14.0825 3.78219 14.0825 4.09657C14.0825 4.41094 14.0551 4.66579 14.0213 4.66579H8.88839C8.85457 4.66579 8.82715 4.41094 8.82715 4.09657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9886 1.07947C12.1297 0.926637 12.3585 0.926637 12.4996 1.07947L15.0288 3.81886C15.1699 3.97169 15.1699 4.21948 15.0288 4.3723L12.4996 7.1117C12.3585 7.26453 12.1297 7.26453 11.9886 7.1117C11.8475 6.95887 11.8475 6.71109 11.9886 6.55826L14.2623 4.09558L11.9886 1.63291C11.8475 1.48008 11.8475 1.23229 11.9886 1.07947Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.09713C0 3.71988 0.0493515 3.41406 0.11023 3.41406H9.34948C9.41036 3.41406 9.45971 3.71988 9.45971 4.09713C9.45971 4.47438 9.41036 4.7802 9.34948 4.7802H0.11023C0.0493515 4.7802 0 4.47438 0 4.09713Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardNextDisabledIcon);
export default __webpack_public_path__ + "static/media/score-card-next-disabled-icon.733c6e4c88bffc8ede28406dfe9d9c86.svg";
export { ForwardRef as ReactComponent };